import { render, staticRenderFns } from "./weight-scan.vue?vue&type=template&id=c6730e68&scoped=true&"
import script from "./weight-scan.vue?vue&type=script&lang=ts&"
export * from "./weight-scan.vue?vue&type=script&lang=ts&"
import style0 from "./weight-scan.vue?vue&type=style&index=0&id=c6730e68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6730e68",
  null
  
)

export default component.exports